import { render } from "./EventDetails.vue?vue&type=template&id=069febba&scoped=true"
const script = {}

import "./EventDetails.vue?vue&type=style&index=0&id=069febba&lang=scss&scoped=true"

import exportComponent from "/Users/vonwong/Dropbox/ClaudeCode/MeetingOS/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069febba"]])

export default __exports__